export const getEmojiByAmount = (amount: number): string => {
  const defaultEmoji = '💵'
  const thresholds = [
    { limit: 500, emoji: '💰' },
    { limit: 100, emoji: '🤑' },
    { limit: 50, emoji: '💸' },
    { limit: 10, emoji: '💳' }
  ]

  return thresholds.find(({ limit }) => amount >= limit)?.emoji || defaultEmoji
}
